import { param, route } from "typesafe-react-router";

export const petsRoutes = {
    index: route("pets"),
    lostPets: route("lostpets"),
    pet: route("pets", param("id")),
    searchPets: route("searchpets"),
};
